import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdministratorsList.scss'
import { Row, Col, Table, FormCheck } from 'react-bootstrap'
import PrimaryActionButton from '../../../../common/Buttons/PrimaryActionButton'
import SubmitSpinner from '../../../../common/Spinners/SubmitSpinner'

const renderAdministrator = (admin, index, submitting, submitted, toggleAdminActive, updateIndex) => {
  return <tr key={admin.administratorId}>
    <td>{admin.emailAddress}</td>
    <td>{admin.firstName}</td>
    <td>{admin.lastName}</td>
    <td>
      <FormCheck
        type="checkbox"
        className={`${styles['inline-block']|| ''} ${styles.smallCheckbox || ''}`}
        disabled={submitting}
        checked={admin.isActive}
        onChange={toggleAdminActive}
      />

      {updateIndex === index && submitting && <SubmitSpinner className={styles['inline-block']} />}
    </td>
  </tr>
}

const AdministratorsList = ({ administrators, toggleAdminActive, submitting, submitted, addAdmin, updateIndex }) => {
  return <div>
    <Row>
      <Col sm={8} md={8} lg={8} className="d-none d-sm-block">
        <h1 className={styles['heading']} >Administrators</h1>
      </Col>
      <Col sm={4} md={4} lg={4} className={`d-none d-sm-block ${styles['text-right']}`}>
        <PrimaryActionButton
          className={styles['inline-block']}
          onClick={addAdmin}
          preventDefault
          buttonText='Add Administrator'
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
        <Table striped size='sm' bordered hover>
          <thead>
            <tr>
              <th>Email Address</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th className={styles['fixed-width-is-active']}>Is Active</th>
            </tr>
          </thead>
          <tbody>
            {administrators.map((admin, index) => {
              return renderAdministrator(admin, index, submitting, submitted, () => toggleAdminActive(index), updateIndex)
            })}
          </tbody>
        </Table>
      </Col>
    </Row>
  </div>
}

AdministratorsList.propTypes = {
  administrators: PropTypes.array.isRequired,
  toggleAdminActive: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  submitted: PropTypes.bool.isRequired,
  addAdmin: PropTypes.func.isRequired,
  updateIndex: PropTypes.number.isRequired
}

export default (AdministratorsList)
